import { Component, OnInit } from '@angular/core';
import {IonicModule, ModalController, NavParams} from '@ionic/angular'
import {Validators, FormBuilder, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {AukceImage} from '../models/aukceImage';
import {NgIf} from "@angular/common";
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

addIcons({
  'close': closeOutline,
});

@Component({
  selector: 'app-prihodit',
  templateUrl: './prihodit.page.html',
  styleUrls: ['./prihodit.page.scss'],
  imports: [
    IonicModule,
    ReactiveFormsModule,
    NgIf
  ],
  standalone: true
})
export class PrihoditPage implements OnInit {

  prihoditForm:UntypedFormGroup
  parentPrihodit
  photo: AukceImage

  constructor(
    public params: NavParams,
    public fb: FormBuilder,
    private modalCtrl: ModalController
  ) {
    this.photo = this.params.get('photo')
    this.parentPrihodit = this.params.get('prihodit')

    this.prihoditForm = this.fb.group({
      'prihoz': [null, [Validators.required, Validators.min(this.photo.currentPrice + 50), Validators.pattern('[0-9]*')]],
    })

   }

  ngOnInit() {
  }

  close() {
    this.modalCtrl.dismiss()
  }

  // This is actually not called and is only a placeholder function to satisfy the compiler
  dismissPrihoditModal() {}

  prihodit(a: any, b: any) {
    // the function that's called resides in home.page.ts
    // prihodit()


    // let prihoz = Number(this.prihoditForm.value.prihoz)
    // console.log(prihoz, this.photo)
    // if (Number.isInteger(prihoz)) {
    //   this.photo.currentPrice = prihoz
    //   console.log(prihoz, this.photo)
    //   // this.parentPrihodit(this.photo, prihoz)
    // }
  }

}
